<template>
  <div class="award_bg" :style="frameW">
    <div class="award_content" :style="contentH">
      <div class="child_content">
        <ul>
          <li class="award_list" v-for="(item,index) in awardList" :key="index">
            <p><i class="square"></i>{{item.dateline}}</p>
            <p :class="{'active' : !item.have_submit_msg, 'point': item.type === 4}" @click="inputInfo(item)">{{item.prize_name}}</p>
            <template v-if="/[124]/.test(item.type)">
              <p v-if="item.status=='1'" class="Unreceived" @click="inputInfo(item)">未领取</p>
              <p v-if="item.status=='2'" class="received" >已领取</p>
              <p v-if="item.status=='3'" class="received" @click="recovery">已回池</p>
            </template>
            <p v-else-if="/[3]/.test(item.type)" class="received" @click="goPrizeUrl(item.prize_url)">领取</p>
          </li>
        </ul>
      </div>
    </div>
    <!-- 虚拟奖品领取 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVerification" center :show-close="false" :close-on-click-modal="false">
      <span v-html="showFields.verifycation_info"></span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" class="lottery-receive pop_btn" @click="dialogVerification = false">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog :visible.sync="showRecovery" center :show-close="false" :close-on-click-modal="false">
      <span>您的奖品已被管理员回池，无法领取，如有疑问，请联系公众号管理员！</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" class="pop_btn" @click="showRecovery = false">确 定</el-button>
      </span>
    </el-dialog>

    <div class="return_btn" @click="backIndex">
        <p>返回活动</p>
    </div>
    <!-- 实物中奖弹窗 -->
    <formDialog
      :formDialogDisplay.sync="formDialogDisplay"
      :isReload="true"
      :title="formDialogTitle"
      :id="id"
      :formList="formList"></formDialog>
  </div>
</template>

<script>
import FormDialog from 'components/formDialog/formDialog'

export default {
  data () {
    return {
      msg: '我的中奖记录页面',
      formDialogDisplay: false,
      formDialogTitle: '请将下列信息补充完整，以便后续奖品发放！',
      formList: {}, // 中奖表单信息
      activeName: '1',
      awardList:'',
      dialogTitle: '',
      dialogFillIn:false,
      dialogVerification:false,
      award_status:false,
      formLabelWidth:'25%',
      fields:{},
      showFields:{},
      showRecovery:false,
      fillInfo:{},
      judge:{
        name:false,
        tel:false,
        idcard:false,
        add:false
      },
      preview: 0,
      validSubmit:true,
      verification:'',
      id: null // 领奖id
    }
  },
  components: {
      FormDialog
  },
  created(){
    // 添加预览模式
    if (sessionStorage.getItem('preview')) {
      this.preview = 1
    }
    // 防刷新
    document.title = sessionStorage.getItem('raffleTitle')
    setTimeout(() => {
      let shareConfig = JSON.parse(sessionStorage.getItem('shareConfig'))
      // 分享配置，先判断环境
      let vm = this
      CP.set_share({
        title: shareConfig.share_title,
        shareSummary: shareConfig.share_desc,
        shareTo: '',
        link: shareConfig.share_link,
        imgUrl: shareConfig.share_img,
        success:function(data){
          // 因为以下功能仅实现于浙江新闻，为了与其它客户端匹配，所以暂时将它隐藏（分享成功后抽奖次数加1）
          // if(data.success=='1'){
          //   getShareSuccess({
          //       preview: vm.preview
          //   }).then(res => {
          //       console.log('--res-',成功了)
          //   })
          // }
        },
        once: false
      })
    }, 500)

    let _this = this;
    _this.Get({
        url:'/activity/api.php',
        data: {
          m:'front',
          subm:'lottery',
          action:'myprize',
          preview: _this.preview
        },
        success:function(data){
          _this.awardList = data.data;

        },
        error: function(data){

        }
    });
  },
  computed: {
    frameW(){
      let s_width = document.body.clientWidth;
      let s_height = document.body.clientHeight;
        return{
            width:s_width+'px'||'100%',
            height:s_height+'px'||'100%'
        }
    },
    contentH(){
      let s_height = document.body.clientHeight;
      let content_h = (980*s_height)/1334; // 73.5%
      return{
        height:content_h+'px'
      }

    }
  },
  methods:{
    inputInfo(data) {
      if (data.type != 4 && data.have_submit_msg === 1) return
      if (data.type == '1') {//实物
        this.id = data.id;
        for(let i=0;i<data.receive_msg.length;i++){
          let item = data.receive_msg[i]
          this.formList[item] = ''
        }
        this.formDialogDisplay = true;
      } else if (data.type == '2') {//虚拟奖品
        this.dialogTitle = '请记录您的账号信息'
        this.showFields.verification_id = data.verification_id;
        this.showFields.verifycation_info = data.verifycation_info;
        this.dialogVerification = true;
      } else if(data.type == 4) {
        this.dialogTitle = '客户端积分'
        this.showFields.verifycation_info = `${data.app_name}：${data.points}积分`;
        this.dialogVerification = true;
      }
    },
    backIndex() {
      this.$router.push('/');
    },
    recovery() {
      this.showRecovery = true;
    },
    goPrizeUrl(url) {
      window.location.href = url;
    }
  }
}
</script>
<style scoped>
.award_bg{
  overflow-y: hidden;
  background-image: url('../assets/images/award_bg.png');
  background-size: 100% 100%;
}
.award_content{
  width: 85%;
  margin: 0 auto;
  margin-top: 20%;
  text-align: left;
  overflow: hidden;
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
}
.award_list{
/*    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-pack: distribute;
    justify-content: space-between;
    -webkit-justify-content: space-between;*/
    display: -webkit-flex; /* Safari */
    display: flex;
    -webkit-justify-content: space-around;
    justify-content: space-around;
    -webkit-justify-content:space-around;
    border-bottom: 1px solid#b23c4a;
    padding: 3% 0;
}
.square{
  display: inline-block;
  width: 10px;
  height: 10px;
  background-color:#b23c4a;
  margin-right: 5px;
}
.received{
    width: 55px;
    background-color: #f41848;
    text-align: center;
    border-radius: 5px;
    color: #fff;
}
.Unreceived{
    width: 55px;
    background-color: #f3b718;
    text-align: center;
    border-radius: 5px;
    color: #fff;
}
.award_list p{
    flex:1;
    text-align: left;
}
.child_content li:nth-last-of-type(1){
  border-bottom: none;
}
.child_content ul{
  font-size: 0.8rem;
}
.award_list p:nth-child(3){
    flex: 0 0 55px;
    text-align: center;
    padding: 1% 0;
}
.award_list p:nth-child(1){
    flex: 0 0 40%;
}
.award_list p:nth-child(2){
    margin: 0 1%;
}
.return_btn{
    position: absolute;
    bottom: 2%;
    width: 100%;
}
.return_btn p{
    background-color: #fde338;
    color: #e21742;
    width: 100px;
    border-radius: 5%;
    margin: 0 auto;
    padding: 5px 0px;
}
.award_bg .point,
.active{
    color:#608ac6;
    text-decoration:underline;
}
</style>



// WEBPACK FOOTER //
// src/page/awardList.vue